<template>
    <div class="hts-auth-reset-password">
        <div class="hts-auth-reset-password__container">
            <!--  LEFT -->
            <div class="container-left">
                <div class="container">
                    <div v-if="showForm">
                        <div class="title">
                            <img
                                class="h-12 w-auto"
                                :src="logoUrl"
                                alt="Logo"
                                @error="onLogoError" >
                        </div>
                        <div class="title mt-3">
                            <h2 class="text">
                                {{ $t('labels.resetPassword') }}
                            </h2>
                        </div>
                        <div class="input-container">
                            <hts-form
                                :rules="validationRules"
                                class="space-y-6"
                                @submit="handleSubmitFormResetPassword">
                                <!-- Password -->
                                <div class="space-y-1">
                                    <hts-form-input
                                        v-model="formData.newPassword"
                                        :placeholder="$t('labels.newPassword')"
                                        name="newPassword"
                                        prop="newPassword"
                                        type="password">
                                        <template #prefix>
                                            <hi-lock-closed-icon class="h-6 w-6 ml-2 text-gray-500" />
                                        </template>
                                    </hts-form-input>
                                </div>

                                <!-- Confirm Password -->
                                <div class="space-y-1">
                                    <hts-form-input
                                        v-model="formData.confirmNewPassword"
                                        :placeholder="$t('labels.confirmNewPassword')"
                                        name="confirmNewPassword"
                                        prop="confirmNewPassword"
                                        type="password">
                                        <template #prefix>
                                            <hi-lock-closed-icon class="h-6 w-6 ml-2 text-gray-500" />
                                        </template>
                                    </hts-form-input>
                                </div>

                                <hts-form-button
                                    :loading="loading"
                                    class="form-button"
                                    color="primary"
                                    type="submit">
                                    <span class="absolute left-0 inset-y-0 flex items-center pl-3" />
                                    <p class="flex items-center justify-center">
                                        {{ $t('labels.changePassword') }}
                                        <hi-arrow-path-icon class="h-6 w-6 ml-2 rotate-180" />
                                    </p>
                                </hts-form-button>
                            </hts-form>
                        </div>
                    </div>

                    <div v-if="!showForm && typeAlert">
                        <hts-alert
                            :show="true"
                            :type="typeAlert">
                            {{ infoAlert }}
                        </hts-alert>

                        <div class="mt-5 flex justify-center">
                            <hts-link
                                v-if="typeAlert === 'success' && device != 'mobile'"
                                :to="{ name: 'auth-login' }"
                                class="text-main-500">
                                {{ $t('labels.login') }}
                            </hts-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const route = useRoute()
const typeAlert = ref('error')
const infoAlert = ref('')
const token = computed(() => route.query?.token || '')
const device = computed(() => route.query?.device || '')
const showForm = ref(false)

const logoUrl = computed(() => {
  const defaultLogoUrl = '/assets/logo.png'
  return defaultLogoUrl
})

const onLogoError = (event: Event) => {
  const target = event.target as HTMLImageElement
  target.style.display = 'none'
}

/* routes */
const validationRules = {
  newPassword: 'required|regexPassword|min:6|max:40',
  confirmNewPassword: 'required|confirmed:@newPassword'
}

/* Handle submit */
const initForm = {
  newPassword: '',
  confirmNewPassword: ''
}
const formData = ref({ ...initForm })

const loading = ref(false)
const loadingPage = ref(true)

const resetForm = () => {
  formData.value = { ...initForm }
}
/* */
definePageMeta({
  layout: 'auth'
})

const handleSubmitFormResetPassword = async () => {
  loading.value = true

  const api = {
    url: '/auth/reset-password',
    method: 'post'
  }

  const dataForm = {
    token: token.value,
    password: formData.value.newPassword
  }

  const data: any = await $api(api, {
    body: dataForm
  })

  const resData: any = data?.data.value
  const resError: any = data?.error

  if (resData) {
    if (resData.success) {
      if (process.client) {
        resetForm()
        $toast().success(resData.data)
        typeAlert.value = 'success'
        infoAlert.value = resData.data
        showForm.value = false
      }
    }
  } else if (resError.value?.data === undefined) {
    if (process.client) {
      $toast().error('Không thể kết nối tới máy chủ')
    }
  } else {
    if (process.client) {
      $toast().error(resError.value.data.errors[0])
    }
    typeAlert.value = 'error'
    infoAlert.value = resError.value.data.errors[0]
    showForm.value = false
  }

  loading.value = false
}

onMounted(async () => {
  const api = {
    url: '/auth/reset-password-confirm',
    method: 'post'
  }

  const data: any = await $api(api, {
    body: { token: token.value }
  })

  const resData: any = data?.data.value
  const resError: any = data?.error
  if (resData?.success) {
    loadingPage.value = false
    showForm.value = true
  } else {
    infoAlert.value = resError.value.data.errors[0]
  }
})
</script>
